@if (init && isAuthenticated) {
  <div>
    @if (isHeadless) {
      <app-header></app-header>
    } @else {
      <website-navigation-head [config]="configHead"></website-navigation-head>
    }
    <app-info-header></app-info-header>
    <router-outlet (activate)="onActivate($event)"></router-outlet>
    @if (!isHeadless) {
      <website-navigation-footer [config]="configFooter"></website-navigation-footer>
    }
  </div>
}

